import type { BetterstartPresetId } from '@cli-types/preset-engine/presets.js'
import { parseIdList } from '@core-engine/installable/protocol/parse-id-list.js'
import { formatUnknownPresetMessage, isPresetId } from '@next-adapter/preset-registry.js'

export function parsePresetList(value: string | undefined): BetterstartPresetId[] {
  return parseIdList(value, isPresetId, formatUnknownPresetMessage)
}
